import * as React from 'react';
import { Check } from 'lucide-react';
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';

import { cn } from '@shared/utils/cn';

const RadioGroup = ({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Root>) => (
  <RadioGroupPrimitive.Root className={cn('grid gap-3', className)} data-slot="radio-group" {...props} />
);

// Radio classique (pastille 20px)
const RadioGroupItem = ({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Item>) => (
  <RadioGroupPrimitive.Item
    className={cn(
      "relative aspect-square size-5 shrink-0 rounded-full border-2 border-muted-foreground/60 outline-none transition-colors after:absolute after:-inset-2.5 after:content-[''] focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary",
      className
    )}
    data-slot="radio-group-item"
    {...props}
  >
    <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
      <span className="size-2.5 rounded-full bg-primary" />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
);

// Choix sous forme de carte sélectionnable (min 88px de haut, coche quand sélectionné)
const RadioGroupCard = ({ className, children, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Item>) => (
  <RadioGroupPrimitive.Item
    className={cn(
      'group flex min-h-22 items-center gap-3 rounded-lg border-2 border-border p-3 text-left outline-none transition-colors hover:bg-accent focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary/8',
      className
    )}
    data-slot="radio-group-card"
    {...props}
  >
    {children}
    <Check aria-hidden className="ml-auto hidden size-4 shrink-0 text-primary group-data-[state=checked]:block" />
  </RadioGroupPrimitive.Item>
);

export { RadioGroup, RadioGroupCard, RadioGroupItem };
